<template>
  <div class="tw-relative">
    <div class="pricing-wrapper">
      <h1 class="tw-text-3xl sm:tw-text-4xl tw-mb-4">Rechnungsfuchs ist günstig</h1>

      <div class="tw-w-full tw-max-w-3xl tw-text-xl tw-mb-4">
        <p class="tw-text-gray-500 tw-mb-4">Rechnungsfuchs hilft Selbständigen Ihre Buchhaltung und Briefkommunikation zu einem guten Preis-/Leistungsverhältnis professionell geregelt zu kriegen.</p>
        <p class="tw-font-semibold">14 Tage gratis</p>
      </div>

      <div class="pricing-cards tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-8 lg:tw-gap-6">
        <div class="pricing-card tw-p-6 tw-rounded-lg tw-border tw-border-gray-100">
          <span class="tw-block tw-text-2xl tw-font-semibold tw-text-center tw-mb-3">Basic</span>
          <span class="tw-block tw-text-lg tw-text-gray-500 tw-text-center tw-mb-8">Hauptfunktionen und Support</span>

          <div class="tw-flex tw-justify-center tw-items-end tw-gap-3 tw-mb-6">
            <span class="tw-text-5xl tw-font-extrabold">19,90€</span>
            <span class="tw-text-gray-500">netto /Monat</span>
          </div>

          <div class="tw-flex tw-flex-col tw-gap-4 tw-mb-6">
            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>Rechnungsgenerator</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>Briefgenerator</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>ZUGPFeRD & X-Rechnung</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CancelIcon />
              <span>Briefversand: via Deutsche Post API</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>Support: <span class="tw-font-bold">per Email, 24-48h</span></span>
            </div>
          </div>

          <button class="btn-gradient tw-w-full tw-font-bold" @click="verifyStatusAndPlan('basicMonthly')">
            Los geht’s!
          </button>
        </div>

        <div class="pricing-card tw-p-6 tw-rounded-lg tw-border tw-border-gray-100">
          <span class="tw-block tw-text-2xl tw-font-semibold tw-text-center tw-mb-3">Basic (Jahr)</span>
          <span class="tw-block tw-text-lg tw-text-gray-500 tw-text-center tw-mb-8">20% günstiger als Monatsplan</span>

          <div class="tw-flex tw-justify-center tw-items-end tw-gap-3 tw-mb-6">
            <span class="tw-text-5xl tw-font-extrabold">199€</span>
            <span class="tw-text-gray-500">netto /Jahr</span>
          </div>

          <div class="tw-flex tw-flex-col tw-gap-4 tw-mb-6">
            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>Rechnungsgenerator</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>Briefgenerator</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>ZUGPFeRD & X-Rechnung</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CancelIcon />
              <span>Briefversand: via Deutsche Post API</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>Support: <span class="tw-font-bold">per Email, 24-48h</span></span>
            </div>
          </div>

          <button class="btn-gradient tw-w-full tw-font-bold" @click="verifyStatusAndPlan('basicYearly')">
            Los geht’s!
          </button>
        </div>

        <div class="pricing-card tw-p-6 tw-rounded-lg border-primary">
          <span class="tw-block tw-text-2xl tw-font-semibold tw-text-center tw-mb-3">Premium</span>
          <span class="tw-block tw-text-lg tw-text-gray-500 tw-text-center tw-mb-8">extra Service und Funktionen</span>

          <div class="tw-flex tw-justify-center tw-items-end tw-gap-3 tw-mb-6">
            <span class="tw-text-5xl tw-font-extrabold">149€</span>
            <span class="tw-text-gray-500">netto /Monat</span>
          </div>

          <div class="tw-flex tw-flex-col tw-gap-4 tw-mb-6">
            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>Rechnungsgenerator</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>Briefgenerator</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>ZUGPFeRD & X-Rechnung</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>Briefversand: via Deutsche Post API</span>
            </div>

            <div class="tw-flex tw-items-center tw-gap-3">
              <CheckIcon />
              <span>Support: <span class="tw-font-bold">per Email, 24-48h</span></span>
            </div>
          </div>

          <button class="btn-gradient tw-w-full tw-font-bold" @click="verifyStatusAndPlan('premiumMonthly')">
            Los geht’s!
          </button>
        </div>
      </div>
    </div>

    <AppModal v-if="isEmailModal" @close="closeEmailModal">
      <div class="login-form">
        <h2>
          <img
          class="fox-logo-row"
          :src="require('@/assets/images/rechnungsfuchs_logo_langform_schwarz.png')"
          alt="Rechnungsfuchs Logo">
        </h2>
        <v-form ref="form" v-model="valid">
          <div class="p-fluid">
            <div class="p-field">
              <label for="username">Email</label>
              <InputText id="email"
                v-model="email"
                required
              />
              <small v-if="emailError" class="p-error">{{ emailError }}</small>
            </div>

            <div class="p-field">
              <AppButton
                label="Bestätigen"
                icon="pi pi-check"
                @click="confirmSubscription()"
                class="login-button"
              />
            </div>
          </div>
        </v-form>
      </div>
    </AppModal>
  </div>
</template>

<script>
import CheckIcon from '@/views/Pricing/icons/CheckIcon.vue'
import CancelIcon from '@/views/Pricing/icons/CancelIcon.vue'
import ApiService from '@/services/api.service'
import { loadStripe } from '@stripe/stripe-js'
import AppModal from '@/components/Common/AppModal.vue'

export default {
  name: 'PricingView',
  components: { CheckIcon, CancelIcon, AppModal },
  data () {
    return {
      subPlanRef: '',
      isEmailModal: false,
      valid: false,
      email: '',
      emailError: ''
    }
  },
  methods: {
    closeEmailModal () {
      this.isEmailModal = false
    },
    validateForm () {
      let isValid = true

      this.emailError = ''

      // Email validation
      if (!this.email) {
        this.emailError = 'E-mail required'
        isValid = false
      } else if (!/.+@.+\..+/.test(this.email)) {
        this.emailError = 'E-mail must be valid'
        isValid = false
      }

      return isValid
    },
    async verifyStatusAndPlan (subPlan) {
      this.subPlanRef = subPlan

      try {
        const userResponse = await ApiService.get('/user/status')

        const userEmail = userResponse.data.email

        this.subsribe(this.subPlanRef, userEmail)
      } catch (error) {
        this.isEmailModal = true
      }
    },
    confirmSubscription () {
      if (this.validateForm()) {
        this.subsribe(this.subPlanRef, this.email)
        this.closeEmailModal()
      }
    },
    async subsribe (subPlan, email) {
      try {
        const response = await ApiService.post('/subscription/session', {
          email, subPlan
        })

        const stripe = await loadStripe(process.env.VUE_APP_STRIPE_TOKEN)
        const { error } = await stripe.redirectToCheckout({
          sessionId: response.data.sessionId
        })

        if (error) {
          console.error('Stripe checkout error', error)
        }
      } catch (error) {
        console.error('Subscription error:', error)
      }
    }
  }
}
</script>

<style scoped>
.login-form {
  width: 33%;
  min-width: 300px;
  max-width: 550px;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: relative;
  z-index: 50;
}

.p-field {
  margin-bottom: 1rem;
}

h2 {
  text-align: center;
  margin-bottom: 1rem;
}

/* Button color customization */
.login-button {
  background: linear-gradient(248deg, #FB3B1F -2.45%, #F82A3F 42.25%, #EF008A 95.81%);
  border: none;
  color: white;
}

.login-button:hover {
  background: linear-gradient(248deg, #FB3B1F -2.45%, #F82A3F 42.25%, #EF008A 95.81%) !important;
}

/* Styling for the links */
.p-text-center {
  text-align: center;
  margin-top: 1rem;
}

.link {
  color: #007bff;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

/* Specific styles for the Register and Forgot Password links */
.register-link {
  color: black;
}

.forgot-password-link {
  color: black;  /* Change text color for Forgot Password to black */
}

.register-link strong {
  font-weight: bold;  /* Make Register text bold */
}

@media (max-width: 768px) {
  .login-form {
    width: 80%;  /* Make form take 80% width on small screens */
  }
}
</style>
